module.exports = __webpack_public_path__ + "img/clipboard.b027a8b9.svg";